import { Component, inject, Injector, LOCALE_ID, signal } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, StatusChangeEvent, Validators } from '@angular/forms';

import { environment } from '../../../environments/environment';

import { RECAPTCHA_LOADER_OPTIONS, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { firstValueFrom, takeWhile } from 'rxjs';
import { DataService } from '../../data-service';
import { getLanguage } from '../../app.service';
@Component({
    selector: 'iea-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    imports: [ReactiveFormsModule, RecaptchaV3Module],
    standalone: true,
    providers: [
        {
            provide: RECAPTCHA_LOADER_OPTIONS,
            useFactory: (locale: string) => {
                return {
                    onBeforeLoad(url) {
                        url.searchParams.set('hl', locale);
                        return { url };
                    },
                };
            },
            deps: [LOCALE_ID],
        },
    ],
})
export class ContactUsComponent {
    recaptchaKey = environment.recaptchaKey;
    emilPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
    private readonly dataService = inject(DataService);
    private readonly fb = inject(FormBuilder);
    form = this.fb.group({
        'g-recaptcha-response': new FormControl(''),
        email: new FormControl('', [Validators.required, Validators.pattern(this.emilPattern)]),
        message: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
        url: new FormControl(''),
        time: new FormControl(new Date()),
    });

    processing = signal(false);
    private readonly injector = inject(Injector);
    lan = getLanguage(this.injector);
    recaptchaService: ReCaptchaV3Service;
    constructor() {
        this.form.events.pipe(takeWhile(() => !this.recaptchaService)).subscribe((e) => {
            if (e instanceof StatusChangeEvent) {
                if (e.status === 'VALID') {
                    this.processing.set(true);
                    this.recaptchaService = this.injector.get(ReCaptchaV3Service);
                    this.recaptchaService.recaptchaLoader.ready.subscribe(() => {
                        this.processing.set(false);
                    });
                }
            }
        });
    }
    async send() {
        try {
            this.processing.set(true);
            if (!this.recaptchaService) this.recaptchaService = this.injector.get(ReCaptchaV3Service);

            const token = await firstValueFrom(this.recaptchaService.execute('importantAction'));
            this.form.patchValue({ 'g-recaptcha-response': token } as any);

            await this.dataService.post('messages', {
                ...this.form.value,
                url: location.href,
                time: new Date(),
            });
            this.form.reset();
        } catch (e) {
            console.error(e);
        } finally {
            this.processing.set(false);
        }
    }
}
